import type { DashboardVariable } from "../../../../common/dashboard-spec";

export const VARIABLE_VALUE_FALLBACK_STRING = "None";

export interface VariableState {
	variable: DashboardVariable;
	initialVariable: DashboardVariable;
}
